import PC1 from "../images/ProfessionalsCarousel1.jpg"
import PC2 from "../images/ProfessionalsCarousel2.jpg"
import PC3 from "../images/ProfessionalsCarousel3.jpg"
import PC4 from "../images/Website Banners-04.png"

export default {
  professionals: [PC1, PC2, PC3,PC4],
}
